module.exports = __webpack_public_path__ + "img/bg.f8ed4915.png";